import React, { useState, useEffect } from 'react';
import { fetchUserArticles } from '../../js/services/admin-api'; // Adjusted imports
import ChartToggle from '../../js/components/Layout/ChartToggle'; // Adjust the path accordingly
import { Pie, Bar, Line } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register necessary Chart.js elements
Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels, CategoryScale, LinearScale, BarElement);

const Reports = () => {
    const [data, setData] = useState([]);
    const [chartTypes, setChartTypes] = useState({
        userId: 'bar',
        userIdPerDay: 'line',
        step: 'pie',
        userCreatedAt: 'bar',
        detailedStep: 'bar',
    });

    useEffect(() => {
        const getData = async () => {
            try {
                const articles = await fetchUserArticles();
                setData(articles);
            } catch (error) {
                console.error('Error fetching articles:', error);
            }
        };
        getData();
    }, []);

    const createChartData = (labels, values) => ({
        labels,
        datasets: [{
            data: values,
            backgroundColor: [
              '#FF6384', // Red
              '#36A2EB', // Blue
              '#FFCE56', // Yellow
              '#4BC0C0', // Teal
              '#9966FF', // Purple
              '#FF9F40', // Orange
              '#FF5733', // Light Red
              '#33FF57', // Light Green
              '#3357FF', // Light Blue
              '#FFC300'  // Gold
          ],
        }],
    });

    const userIdTotal = () => {
        const userCounts = data.reduce((acc, article) => {
            acc[article.email] = (acc[article.email] || 0) + 1;
            return acc;
        }, {});

        const sortedCounts = Object.entries(userCounts)
            .sort(([, countA], [, countB]) => countB - countA)
            .slice(0, 10); // Get top 10

        return createChartData(sortedCounts.map(([email]) => email), sortedCounts.map(([, count]) => count));
    };

    const userIdPerDayTotal = () => {
        const dateCounts = data.reduce((acc, article) => {
            const date = new Date(article.created_at).toLocaleDateString();
            if (!acc[date]) {
                acc[date] = new Set();
            }
            acc[date].add(article.user_id);
            return acc;
        }, {});

        const sortedCounts = Object.entries(dateCounts)
            .map(([date, userSet]) => [date, userSet.size])
            .sort((a, b) => new Date(a[0]) - new Date(b[0]));

        return createChartData(sortedCounts.map(([date]) => date), sortedCounts.map(([, count]) => count));
    };

    const stepTotal = () => {
        const stepCounts = data.reduce((acc, article) => {
            const key = `${article.step}`;
            acc[key] = (acc[key] || 0) + 1;
            return acc;
        }, {});
        return createChartData(Object.keys(stepCounts), Object.values(stepCounts));
    };

    const aIUsagePerDayTotal = () => {
        const dateCounts = data.reduce((acc, article) => {
            const date = new Date(article.created_at).toLocaleDateString();
            acc[date] = (acc[date] || 0) + 1;
            return acc;
        }, {});

        const sortedCounts = Object.entries(dateCounts)
            .sort(([, countA], [, countB]) => countB - countA)
            .slice(0, 10);

        return createChartData(sortedCounts.map(([date]) => date), sortedCounts.map(([, count]) => count));
    };

    const setChartType = (chartKey, type) => {
        setChartTypes((prevTypes) => ({
            ...prevTypes,
            [chartKey]: type,
        }));
    };

    return (
        <div>
            <div className="report-grid">
                <div className="grid">
                    <div key="userIdTotal" className="report-card">
                        <p>Top 10 Users AI Usage Statistic</p>
                        <ChartToggle 
                            chartType={chartTypes.userId} 
                            setChartType={(type) => setChartType('userId', type)} 
                            getData={userIdTotal} 
                            xTitle="User"
                            yTitle="AI Usage Count"
                        />
                    </div>
                    <div key="userIdPerDayTotal" className="report-card">
                        <p>Number of Users Using AI Per Day Statistic</p>
                        <ChartToggle 
                            chartType={chartTypes.userIdPerDay} 
                            setChartType={(type) => setChartType('userIdPerDay', type)} 
                            getData={userIdPerDayTotal} 
                            xTitle="Date"
                            yTitle="Number Of Users"
                        />
                    </div>
                    <div key="stepTotal" className="report-card">
                        <p>AI Steps Statistic</p>
                        <ChartToggle 
                            chartType={chartTypes.step} 
                            setChartType={(type) => setChartType('step', type)} 
                            getData={stepTotal} 
                        />
                    </div>
                    <div key="aIUsagePerDayTotal" className="report-card">
                        <p>Top 10 AI Usage Per Day Statistic</p>
                        <ChartToggle 
                            chartType={chartTypes.userCreatedAt} 
                            setChartType={(type) => setChartType('userCreatedAt', type)} 
                            getData={aIUsagePerDayTotal} 
                            xTitle="Date"
                            yTitle="Number Of AI Usage"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reports;